import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Package, ExternalLink } from "lucide-react";
import { useSelector, useDispatch } from "react-redux";
import { Helmet } from "react-helmet";
import ContinuousCodeEditor from "./ContinuousCodeEditor";
import TabbedResultPanel from "./TabbedResultPanel";
import { Link } from "react-router-dom";
import { ChevronDown, Play, AlertCircle, Check, Menu, X } from "lucide-react";
import { executeLesson } from "../../features/courses/courseSlice";
import Header from "../Practice/Header";
import usePracticeData from "../../../hooks/usePracticeDataFromRole";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import Split from "react-split";

const Interview = () => {
  const { selectedRole, lessonList, handleRoleChange, courseDetails } =
  usePracticeData();

  const [horizontalSplitSizes, setHorizontalSplitSizes] = useState([60, 40]);
  const { user, fetchingUser } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const editorRef = useRef(null);

  const [selectedLesson, setSelectedLesson] = useState(null);
  const [executionStatusMap, setExecutionStatusMap] = useState({});
  const [debugLogsMap, setDebugLogsMap] = useState({});
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [showProfilePrompt, setShowProfilePrompt] = useState(false);

  const [contentHeight, setContentHeight] = useState('short');

  const navigate = useNavigate();
  //const [showPackageModal, setShowPackageModal] = useState(false);
//  const [packageURL, setPackageURL] = useState(null);

// const INTERVIEW_PACKAGE_ID = "04tHo000000hCJbIAM";

// const handleCloseModal = () => {
//   setShowPackageModal(false);
// };

// const handleInstallPackage = () => {
//   if (packageURL) {
//     window.open(packageURL, "_blank");
//   }
// };

useEffect(() => {

  if (fetchingUser) return;

  // if (!user[0]) {
  //   navigate("/auth");
  //   return;
  // }

   if (!user[0]?.displayName || !user[0]?.email) {
    setShowProfilePrompt(true);
  }

}, [user, fetchingUser, navigate]);

//   setShowPackageModal(true);

//   // Generate package URL if user has instanceUrl
//   if (user) {
//     setPackageURL(
//       user[0]?.instanceUrl +
//         "/packaging/installPackage.apexp?p0=04tHo000000hCJbIAM"
//     );
//   }
// }, [user, fetchingUser, navigate]);


  useEffect(() => {
    if (lessonList?.length > 0) {
      setSelectedLesson(lessonList[0]);
      const statusMap = lessonList.reduce((map, lesson) => {
        if (lesson.progress?.[0]) {
          map[lesson._id] = {
            data: { success: lesson.progress[0].status === "Completed" },
          };
        }
        return map;
      }, {});
      setExecutionStatusMap(statusMap);
    }
  }, [lessonList]);

  useEffect(() => {
    if (selectedLesson?.lesson) {
      const contentLength = selectedLesson.lesson.length;
      setContentHeight(contentLength > 300 ? 'long' : 'short');
    }
  }, [selectedLesson]);

  // Check if we're on mobile and default the sidebar to closed
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setSidebarOpen(false);
      } else {
        setSidebarOpen(true);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  const handleRunCode = async (lesson) => {
    try {
      const lessonSolution = editorRef.current?.getCurrentContent();
      if (!lessonSolution) return;

      const result = await dispatch(
        executeLesson({
          lessonId: lesson._id,
          apexBody: lessonSolution.trim(),
          lessonType: "continuous",
        })
      ).unwrap();

      setExecutionStatusMap((prev) => ({
        ...prev,
        [lesson._id]: result,
      }));

      setDebugLogsMap((prev) => ({
        ...prev,
        [lesson._id]: result.debugLogs,
      }));
    } catch (error) {
      console.error("Error running code:", error);
      setExecutionStatusMap((prev) => ({
        ...prev,
        [lesson._id]: {
          data: {
            success: false,
            compileProblem: "An error occurred while running the code",
          },
        },
      }));
    }
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="bg-zinc-900 min-h-screen font-mono text-zinc-100">

      {/* <Header
        initialRole={""}
        selectedRole={selectedRole}
        practiceData={practiceData}
        handleRoleChange={handleRoleChange}
      /> */}

      {showProfilePrompt && (
  <div className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4">
    <div className="bg-zinc-800 border border-zinc-700 rounded-lg shadow-xl max-w-sm w-full">
      <div className="p-6 space-y-4 text-center">
        <h2 className="text-xl font-semibold text-lime-300">Before you begin</h2>
        <p className="text-zinc-300 text-sm">
          Please confirm your name and email is correct on your Profile.
        </p>
        <div className="flex justify-center space-x-3 pt-2">
          <button
            onClick={() => {
              setShowProfilePrompt(false);
              window.open("/auth", "_blank");
            }}
            className="px-4 py-2 bg-gradient-to-r from-lime-600 to-cyan-700 hover:from-lime-700 hover:to-cyan-800 text-white rounded-md shadow"
          >
            Go to Profile Setup
          </button>
          <button
            onClick={() => setShowProfilePrompt(false)}
            className="px-4 py-2 bg-zinc-700 text-zinc-300 hover:bg-zinc-600 rounded-md"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
)}



      {/* Main wrapper with shared background */}
      <div className="h-screen overflow-hidden">
      <div className="bg-zinc-800/20 border border-zinc-700/50 shadow-lg h-full">
        <div className="flex h-full">
            {/* Sidebar Toggle for Mobile */}
            <button
              className="md:hidden fixed bottom-4 right-4 z-50 bg-lime-600 hover:bg-lime-700 text-white p-3 rounded-full shadow-lg transition-colors"
              onClick={toggleSidebar}
            >
              {sidebarOpen ? <X size={20} /> : <Menu size={20} />}
            </button>

      {/* Left Sidebar */}
<div className={`${
  sidebarOpen ? "translate-x-0 md:w-80" : "-translate-x-full md:translate-x-0 md:w-12"
} transform transition-all duration-300 ease-in-out fixed md:relative z-40 md:z-auto h-full bg-zinc-800/40 md:bg-transparent md:border-r border-zinc-700/50 flex flex-col`}>

  {/* Sidebar Header with Course Selection */}
  <div className={`bg-gradient-to-r from-zinc-800/80 to-zinc-800/60 border-b border-zinc-700/50 flex-shrink-0 transition-all duration-300 ${
    sidebarOpen ? "px-4 py-4" : "px-2 py-3"
  }`}>
    
    {sidebarOpen ? (
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-medium text-transparent bg-clip-text bg-gradient-to-r from-lime-400 to-cyan-400">
            Challenges 
          </h2>
          <button
            className="text-zinc-400 hover:text-lime-400 transition-colors"
            onClick={toggleSidebar}
            aria-label="Collapse sidebar"
          >
            <ChevronDown size={20} className="transform rotate-[-90deg]" />
          </button>
        </div>

   
      </div>
    ) : (
      /* Collapsed State Header */
      <div className="flex flex-col items-center space-y-2">
        {/* Role indicator when collapsed */}
        {selectedRole !== "{Your Role}" && (
          <div className="w-8 h-8 bg-lime-500/20 rounded-full flex items-center justify-center text-xs text-lime-300 font-bold">
            {selectedRole.charAt(0)}
          </div>
        )}
        <button
          className="text-zinc-400 hover:text-lime-400 transition-colors"
          onClick={toggleSidebar}
          aria-label="Expand sidebar"
        >
          <ChevronDown size={20} className="transform rotate-90" />
        </button>
      </div>
    )}
  </div>

  {/* Scrollable Content Area */}
  {sidebarOpen ? (
    <div className="flex-1 overflow-y-auto custom-scrollbar">
      {lessonList?.map((lesson) => (
        <button
          key={lesson._id}
          onClick={() => {
            setSelectedLesson(lesson);
            if (window.innerWidth < 768) {
              setSidebarOpen(false);
            }
          }}
          className={`w-full flex items-center px-6 py-3 text-left hover:bg-zinc-700/30 transition-colors border-b border-zinc-700/30 ${
            selectedLesson?._id === lesson._id ? "bg-zinc-700/40" : ""
          }`}
        >
          <div className="flex items-center space-x-4">
            <div className={`flex items-center justify-center w-7 h-7 rounded-full ${
              executionStatusMap[lesson._id]?.data?.success 
                ? "bg-lime-500/20 text-lime-300" 
                : "bg-zinc-700 text-zinc-300"
            }`}>
              {executionStatusMap[lesson._id]?.data?.success ? (
                <Check size={12} />
              ) : (
                <span>{lesson.order + 1}</span>
              )}
            </div>
            <h3
              className={`text-base font-medium ${
                executionStatusMap[lesson._id]?.data?.success
                  ? "text-lime-300"
                  : "text-zinc-200"
              }`}
            >
              {lesson.name}
            </h3>
          </div>
        </button>
      ))}
    </div>
  ) : (
    <div className="flex-1 pt-4 overflow-y-auto px-2 space-y-2">
      {lessonList?.map((lesson) => (
        <button
          key={lesson._id}
          onClick={() => {
            setSelectedLesson(lesson);
            setSidebarOpen(true); // Auto-expand when lesson selected
          }}
          className={`w-full flex items-center justify-center p-2 rounded hover:bg-zinc-700/30 transition-colors ${
            selectedLesson?._id === lesson._id ? "bg-zinc-700/40" : ""
          }`}
          title={lesson.name}
        >
          <div className={`flex items-center justify-center w-6 h-6 rounded-full text-xs ${
            executionStatusMap[lesson._id]?.data?.success 
              ? "bg-lime-500/20 text-lime-300" 
              : "bg-zinc-700 text-zinc-300"
          }`}>
            {executionStatusMap[lesson._id]?.data?.success ? (
              <Check size={10} />
            ) : (
              <span>{lesson.order + 1}</span>
            )}
          </div>
        </button>
      ))}
    </div>
  )}
</div>

            {/* Main Content */}
            <div className={`flex-1 overflow-hidden md:min-h-[600px] ${sidebarOpen ? "md:ml-0" : "ml-0"}`}>
              {selectedLesson ? (
                <div className="p-4 md:p-6 space-y-6 h-full">
                  {/* Lesson Title */}
                  <div className="text-center md:text-left">
                    <h1 className="text-2xl md:text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-lime-400 to-cyan-400">
                      {selectedLesson.name}
                    </h1>
                    <div className="h-px bg-gradient-to-r from-lime-500/30 via-cyan-500/30 to-purple-500/30 mt-2"></div>
                  </div>

                  {contentHeight === 'long' ? (
                    // Long content: Resizable split layout with content left, code/results right
                    <div className="h-[calc(70vh)]">

                      <Split
                      key={selectedLesson._id} 
                        sizes={horizontalSplitSizes}
                        onDragEnd={(sizes) => setHorizontalSplitSizes(sizes)}
                        minSize={[300, 250]}
                        maxSize={[800, Infinity]}
                        gutterSize={8}
                        className="split-horizontal"
                        direction="horizontal"
                      >
                        {/* Content Panel */}
<div className="flex flex-col h-full">
  <div className="prose prose-invert max-w-none h-full">
    <div id="lesson-panel" className="p-6 bg-zinc-800/40 rounded-lg border border-zinc-700/50 shadow-lg h-full overflow-y-auto lesson-content custom-scrollbar">
      <ReactMarkdown
        className="text-zinc-300 leading-relaxed text-sm"
        children={selectedLesson.lesson}
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw]}
      />
    </div>
  </div>
</div>
                        
                        {/* Code and Results Panel */}
                        <div className="flex flex-col h-full">
                          <Split
                            sizes={[60, 40]}
                            minSize={[200, 150]}
                            gutterSize={8}
                            className="split-vertical"
                            direction="vertical"
                          >
                            {/* Code Editor */}
                            <div className="bg-zinc-800/40 rounded-lg overflow-hidden ring-1 ring-zinc-700/50 shadow-lg h-full flex flex-col">
                              <div className="flex items-center justify-between p-3 bg-zinc-800/70 border-b border-zinc-700/50 flex-shrink-0">
                                <div className="flex items-center">
                                  <span className="w-1 h-4 bg-lime-500 rounded-sm mr-2"></span>
                                  <span className="text-sm font-medium text-zinc-300">Editor</span>
                                </div>
                              </div>
                              <div className="flex-1 min-h-0">
                                <ContinuousCodeEditor ref={editorRef} lesson={selectedLesson} />
                              </div>
                            </div>

                            {/* Test Results */}
                            <div className="bg-zinc-800/40 rounded-lg overflow-hidden ring-1 ring-zinc-700/50 shadow-lg h-full flex flex-col">
                              <div className="flex items-center justify-between p-3 bg-zinc-800/70 border-b border-zinc-700/50 flex-shrink-0">
                                <div className="flex items-center">
                                  <span className="w-1 h-4 bg-lime-500 rounded-sm mr-2"></span>
                                  <span className="text-sm font-medium text-zinc-300">Test Results</span>
                                </div>
                                {executionStatusMap[selectedLesson._id]?.data?.success ? (
                                  <div className="flex items-center text-lime-400">
                                    <Check size={16} className="mr-1" />
                                    <span className="text-sm">Passed</span>
                                  </div>
                                ) : executionStatusMap[selectedLesson._id] ? (
                                  <div className="flex items-center text-red-400">
                                    <AlertCircle size={16} className="mr-1" />
                                    <span className="text-sm">Failed</span>
                                  </div>
                                ) : null}
                              </div>
                              <div className="p-4 flex-1 overflow-y-auto custom-scrollbar">
                                <TabbedResultPanel
                                  executionStatus={executionStatusMap[selectedLesson._id]}
                                  debugLogs={debugLogsMap[selectedLesson._id]}
                                />
                              </div>
                            </div>
                          </Split>
                        </div>
                      </Split>
                    </div>
                  ) : (
                    // Short content: Original layout with scrollable content
                    <>
                      <div className="prose prose-invert max-w-none">
                        <div className="p-4 md:p-6 bg-zinc-800/40 rounded-lg border border-zinc-700/50 shadow-lg max-h-64 overflow-y-auto lesson-content custom-scrollbar">
                          <ReactMarkdown
                            className="text-zinc-300 leading-relaxed text-sm"
                            children={selectedLesson.lesson}
                            remarkPlugins={[remarkGfm]}
                            rehypePlugins={[rehypeRaw]}
                          />
                        </div>
                      </div>
                      
                      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
                        {/* Code Editor */}
                        <div className="bg-zinc-800/40 rounded-lg overflow-hidden ring-1 ring-zinc-700/50 shadow-lg">
                          <div className="flex items-center justify-between p-3 bg-zinc-800/70 border-b border-zinc-700/50">
                            <div className="flex items-center">
                              <span className="w-1 h-4 bg-lime-500 rounded-sm mr-2"></span>
                              <span className="text-sm font-medium text-zinc-300">Editor</span>
                            </div>
                          </div>
                          <div className="h-96 md:h-[450px]">
                            <ContinuousCodeEditor ref={editorRef} lesson={selectedLesson} />
                          </div>
                        </div>

                        {/* Test Results */}
                        <div className="bg-zinc-800/40 rounded-lg overflow-hidden ring-1 ring-zinc-700/50 shadow-lg">
                          <div className="flex items-center justify-between p-3 bg-zinc-800/70 border-b border-zinc-700/50">
                            <div className="flex items-center">
                              <span className="w-1 h-4 bg-lime-500 rounded-sm mr-2"></span>
                              <span className="text-sm font-medium text-zinc-300">Test Results</span>
                            </div>
                            {executionStatusMap[selectedLesson._id]?.data?.success ? (
                              <div className="flex items-center text-lime-400">
                                <Check size={16} className="mr-1" />
                                <span className="text-sm">Passed</span>
                              </div>
                            ) : executionStatusMap[selectedLesson._id] ? (
                              <div className="flex items-center text-red-400">
                                <AlertCircle size={16} className="mr-1" />
                                <span className="text-sm">Failed</span>
                              </div>
                            ) : null}
                          </div>
                          <div className="p-4 h-[calc(450px-48px)] overflow-y-auto custom-scrollbar">
                            <TabbedResultPanel
                              executionStatus={executionStatusMap[selectedLesson._id]}
                              debugLogs={debugLogsMap[selectedLesson._id]}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {/* Action Buttons */}
                  <div className="flex justify-end pt-2">
                    {!user[0]?.instanceUrl.toString() ? (
                      <Link
                        target="_blank"
                        to={"/auth"}
                        className="flex items-center px-6 py-3 bg-gradient-to-r from-orange-600 to-orange-700 hover:from-orange-700 hover:to-orange-800 text-white rounded-md shadow-lg transition-colors"
                      >
                        <AlertCircle size={16} className="mr-2" />
                        Login To Run Tests
                      </Link>
                    ) : (
                      <button
                        onClick={() => handleRunCode(selectedLesson)}
                        disabled={!selectedLesson}
                        className={`flex items-center px-6 py-3 bg-gradient-to-r from-lime-600 to-cyan-700 hover:from-lime-700 hover:to-cyan-800 text-white rounded-md shadow-lg transition-colors ${
                          !selectedLesson
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }`}
                      >
                        <Play size={16} className="mr-2" />
                        Run Tests
                      </button>
                    )}
                  </div>
                </div>
              ) : (
                <div className="flex items-center justify-center h-full p-8 md:p-12">
                  <div className="text-center">
                    <h2 className="text-xl text-zinc-400">
                      Select a problem to begin
                    </h2>
                    <p className="text-zinc-500 mt-2">
                      Choose from the list on the left side
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Interview;